import axios from 'axios'

const ENDPOINT = 'standard'

export default {
  getTree: async sitePath => {
    const url = `${sitePath}/${ENDPOINT}/tree/`
    const response = await axios.get(url)

    return response.data
  },
  createQStandard: async (sitePath, formdata) => {
    // formdata is a FormData() instance
    const url = `${sitePath}/${ENDPOINT}/`    
    
    const response = await axios({
      method: 'post',
      url: url,
      data: formdata,
      config: { headers: { 'Content-Type': 'multipart/form-data' } },
    })

    return response.data
  },
  getQStandardItems: async (sitePath) => {
    let url = `${sitePath}/${ENDPOINT}/`
    
    const response = await axios.get(url)

    return response.data
  }
}
